<template>
  <el-tooltip effect="dark" :content="value" placement="top">
    <div class="hl-tooltip">{{ value }}</div>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    value: {
      type: String
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.hl-tooltip {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
